import { render, staticRenderFns } from "./FacebookLeads.vue?vue&type=template&id=0bed7c26"
import script from "./FacebookLeads.vue?vue&type=script&lang=js"
export * from "./FacebookLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports